export const GET_STATISTICS_BOUGHT_CHIPS = "GET_STATISTICS_BOUGHT_CHIPS";
export const CLEAR_FILTERS_BOUGHT_CHIPS = "CLEAR_FILTERS_BOUGHT_CHIPS";